import React, { useEffect, useState } from "react";
import { Form, Row, Col, Input, Select, Spin } from "antd";
import axios from "axios";
import API from "@/api";

function ModelDetail(props) {
  const { id } = props;
  const [detail, setDetail] = useState({});
  const [spinning, setSpinning] = useState(true);
  const layout = {
    labelCol: {
      span: 8,
      style: { textAlign: "right", whiteSpace: "normal" },
    },
    wrapperCol: {
      span: 16,
    },
  };

  useEffect(() => {
    axios.get(API.getModelDetailMxgl + `?id=${id}`).then((res) => {
      const data = res?.data?.result?.data || {};
      setDetail(data);
      setSpinning(false);
    });
  }, []);

  return (
    <Spin spinning={spinning}>
      {!spinning ? (
        <>
          <Form
            style={{
              padding: "25px 0",
            }}
            initialValues={{ ...detail }}
          >
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Form.Item {...layout} label="模型ID" name="modelId">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...layout} label="模型名称" name="name">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...layout} label="模型类型" name="categoryName">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...layout} label="参数规模" name="paramSize">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...layout} label="上下文长度" name="context">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item {...layout} label="分类" name="deploymentTypeLabel">
                  <Input disabled />
                </Form.Item>
              </Col>
              {/* <Col span={24}>
            <Form.Item
              labelCol={{
                span: 4,
              }}
              label="接口地址"
              name="email"
            >
              <Input disabled />
            </Form.Item>
          </Col> */}
              <Col span={24}>
                <Form.Item
                  labelCol={{
                    span: 4,
                  }}
                  label="图标"
                  name="email"
                >
                  <img
                    style={{
                      width: "32px",
                      height: "32px",
                    }}
                    src={detail?.iconUrl}
                    alt=" "
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  labelCol={{
                    span: 4,
                  }}
                  label="模型说明"
                  name="description"
                >
                  <Input.TextArea
                    autoSize={{
                      minRows: 3,
                      maxRows: 6,
                    }}
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </>
      ) : null}
    </Spin>
  );
}

export default ModelDetail;
